export default __webpack_public_path__ + "CircularCustCapNum-MediumItalic.4458ae8f42f9b59997f0cf91d06ed686.ttf";